import React, { useState } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import "react-big-calendar/lib/css/react-big-calendar.css";
import { FormControl, FormLabel, FormHelperText, Paper, Grid, Button, Dialog, DialogActions, DialogContent, DialogContentText, ButtonGroup } from '@material-ui/core';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import { indigo, teal, deepPurple, deepOrange, grey, green, brown, blueGrey, red } from '@material-ui/core/colors'
import CustomModal from "../../components/Modal/BookingModal";
import logo from '../../pictures/logo.svg';
import PF from "../../_Services/publicFunction";
import Qs from "qs";
import _, { omit, pick, round, slice } from 'lodash';
import { FormattedMessage, injectIntl, intlShape, useIntl } from 'react-intl';
import Chip from '@material-ui/core/Chip';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const localizer = momentLocalizer(moment);
const isSingle = true;
const DragAndDropCalendar = withDragAndDrop(Calendar)
const useStyles = makeStyles((theme) => ({
    root: {
        padding: 0,
        '&:first-child ': {
            padding: 0,
        }
    },
    appBar: {
        position: 'relative',
        backgroundColor: indigo[500],
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
        textAlign: "center"
    },
    event: {
        borderRight: "3px solid transparent",
        "&:hover": {
            borderRightColor: "blue",
            borderRight: "3px solid",
            opacity: 1,
        },
        "&:focus": {
            borderRightColor: "blue",
            borderRight: "3px solid",
            opacity: 1
        }
    }
}));

const MyCalendar = props => {
    const intl = useIntl();
    const [viewState, setViewState] = useState("week");
    const [dateStart, setDateStart] = useState(moment().toDate());

    const resourceMap = [
        { resourceId: "1", resourceTitle: '17-2會議室' },
        { resourceId: "2", resourceTitle: '17-11會議室' },
    ]
    const departmentMap = {
        //依照部門轉換背景顏色
        "總部": red[900],
        "守葳醫美": teal[500],
        "醫美": teal[500],
        "資訊": indigo[500],
        "管理": deepPurple[500],
        "營銷部": deepOrange[500],
        "健檢部": deepOrange[500],
        "會計": grey[900],
        "人事": grey[500],
        "護理": green[900],
        // "健管部": brown[500],
        "報告組": blueGrey[500]


    }
    const formRef = React.createRef();
    const [open, setOpen] = React.useState(false)
    const [action, setAction] = React.useState("")

    const [settingObj, setObj] = React.useState({
        roomBookingID: { label: "ID", name: "roomBookingID", type: "text", helperText: "required", required: true, noShowSelect: true },
        title: { name: "title", type: "text", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12 },
        department: {
            label: "部門", name: "department", type: "text", helperText: "required", required: true, select: true,
            list: [
                { value: "總部", label: "總部" },
                { value: "守葳醫美", label: "守葳醫美" },
                { value: "醫美", label: "醫美" },
                { value: "資訊", label: "資訊" },
                { value: "管理", label: "管理" },
                { value: "營銷部", label: "營銷部" },
                { value: "健檢部", label: "健檢部" },
                { value: "會計", label: "會計" },
                { value: "人事", label: "人事" },
                { value: "護理", label: "護理" },
                { value: "報告組", label: "報告組" },
            ]
            , xs: 12, sm: 12, md: 12, lg: 12
        },
        resourceId: { label: "地點", name: "resourceId", type: "text", helperText: "required", required: true, select: true, list: [{ value: "1", label: "17-2會議室" }, { value: "2", label: "17-11會議室" }], xs: 12, sm: 12, md: 12, lg: 12 },
        start: { label: "起始", name: "start", type: "text", helperText: "required", readOnly: true, required: true, xs: 12, sm: 12, md: 12, lg: 12 },
        end: { label: "結束", name: "end", type: "text", helperText: "required", readOnly: true, required: true, xs: 12, sm: 12, md: 12, lg: 12 },
        dateCreate: { label: "創建日", name: "dateCreate", type: "text", noShowSelect: true }
    })
    const [user, setUser] = React.useState({
    })
    const validator = () => {
        const form = formRef.current; //參數1

        if (form.checkValidity()) {
            console.log("全部通過");
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (Object.keys(settingObj).includes(element.name)) {
                    setObj(prevState => ({
                        ...prevState,
                        [element.name]: omit(prevState[element.name], ["error"])
                    }))
                }
            }
            return true;
        } else {
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
                    if (Object.keys(settingObj).includes(element.name)) {
                        setObj(prevState => ({
                            ...prevState,
                            [element.name]: { ...prevState[element.name], error: true, helperText: intl.formatMessage({ id: element.validationMessage }) }
                        }))
                    }
                    // console.log(element.validationMessage)

                } else {//驗證通過，自訂訊息
                    //有在settingObj的
                    if (Object.keys(settingObj).includes(element.name)) {
                        setObj(prevState => ({
                            ...prevState,
                            [element.name]: omit(prevState[element.name], ["error"])
                        }))
                    }

                }
            }
            return false;
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        const { start, end, resourceId } = user;

        let timeStart = moment(start, "YYYY/MM/DD HH:mm").toDate();
        let timeEnd = moment(end, "YYYY/MM/DD HH:mm").toDate();

        if (isSingleEvent(user, { resourceId, start: timeStart, end: timeEnd }) !== isSingle) {
            // console.log("不繼續")
            alert("時間重複")
            return;
        }

        if (timeStart < new Date()) {
            alert("時間已過，無法修改");
            return;
        }
        if (validator()) {
            PF.instance({
                method: "POST",
                url: PF.url + "/RoomBooking/" + action,
                data: Qs.stringify({ Action: action, parameter: user }),
                // headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    const { TotalRecord, rows, ErrorMessage } = response.data;
                    console.log(TotalRecord, rows, ErrorMessage)
                    if (TotalRecord <= 0) {
                        alert("錯誤")

                    } else {

                        switch (viewState) {
                            case 'day':
                                getData(moment(dateStart).format("YYYY/MM/DD"), moment(dateStart).format("YYYY/MM/DD"));
                                break;
                            case 'week':
                                getData(moment(dateStart).startOf('week').format("YYYY/MM/DD"), moment(dateStart).endOf('week').format("YYYY/MM/DD"));
                                break;
                            case 'month':
                                getData(moment(dateStart).startOf('month').format("YYYY/MM/DD"), moment(dateStart).endOf('month').format("YYYY/MM/DD"));
                                break;
                            case 'agenda':
                                getData(moment(dateStart).format("YYYY/MM/DD"), moment(dateStart).format("YYYY/MM/DD"));
                                break;
                        }
                        setOpen(false)
                        setAction("")

                    }
                })

        }
    }

    const [myEventsList, setEvent] = React.useState([
        // {
        //     roomBookingID: 1,
        //     start: moment().toDate(),
        //     end: moment()
        //         .add(1, "days")
        //         .toDate(),
        //     title: "Birthday",
        //     color: deepPurple[500],
        //     resourceId: 1
        // }
    ]);
    React.useEffect(() => {
        console.log(myEventsList)
    }, [myEventsList])

    const getData = (start, end) => {
        PF.instance({
            method: "POST",
            url: PF.url + "/RoomBooking/GetData",
            data: Qs.stringify({ parameter: { dateStart: start, dateEnd: end } }),
            // headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                const { TotalRecord, rows, ErrorMessage } = response.data
                if (TotalRecord <= 0) {
                    // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")

                } else {
                    // setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    // setImage("Image");
                    let row = rows.map(item => {
                        return { ...item, color: departmentMap[item.department], resourceId: item.meetingRoomID, start: moment(item.start, 'YYYY-MM-DDTHH:mm').toDate(), end: moment(item.end, 'YYYY-MM-DDTHH:mm').toDate() }
                    })
                    // console.log(row)

                    setEvent(row)

                }
            })

    }
    React.useEffect(() => {
        console.log(user)
    }, [user])

    const [draggedEvent, setDraggedEvent] = React.useState({});
    const [displayDragItemInCell, setDisplayDragItemInCell] = React.useState(true);

    const dragFromOutsideItem = () => {
        return draggedEvent
    }
    const handleDragStart = event => {
        setDraggedEvent(event)
    }
    //滑鼠拖曳：新建事件
    const handleSelect = prop => {
        // console.log(prop)
        const { start, end, resourceId } = prop;
        // console.log(myEventsList);
        if (isSingleEvent(null, prop) !== isSingle) {
            // console.log("不繼續")
            alert("時間重複")
            return;
        }
        if (new Date() > start) {
            alert("時間已過，新預約請選擇之後時間")
        } else {
            setOpen(true);
            setAction("Add")
            setUser(prev => ({
                department: "",
                start: moment(start).format("YYYY/MM/DD HH:mm"),
                end: moment(end).format("YYYY/MM/DD HH:mm"),
                resourceId: resourceId
            }))
        }
    }

    const isSingleEvent = (event, prop) => {
        const { start, end, resourceId } = prop;
        let evnets = myEventsList;

        if (event !== null) {
            //先不算自己
            evnets = evnets.filter(item => item.roomBookingID !== event.roomBookingID)
        }
        let rows = evnets.filter(item => {
            if (item.resourceId === resourceId) {
                if ((item.start < start && item.end > start) || (item.start < end && item.end > end) || (item.start >= start && item.end <= end)) {
                    return item
                }
            }

        })
        // console.log(myEventsList)
        // console.log(rows)
        if (rows.length > 0) {
            return false
        } else {
            return true
        }

    }
    const handleDelete = e => {
        e.preventDefault();
        const { start } = user;
        let timeStart = moment(start, "YYYY/MM/DD HH:mm").toDate();

        if (timeStart < new Date()) {
            alert("時間已過，無法刪除");
        } else {
            PF.instance({
                method: "POST",
                url: PF.url + "/RoomBooking/DELETE",
                data: Qs.stringify({ Action: "DELETE", parameter: user }),
                // headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    const { TotalRecord, rows, ErrorMessage } = response.data;
                    console.log(TotalRecord, rows, ErrorMessage)
                    if (TotalRecord <= 0) {
                        alert("錯誤")

                    } else {

                        switch (viewState) {
                            case 'day':
                                getData(moment(dateStart).format("YYYY/MM/DD"), moment(dateStart).format("YYYY/MM/DD"));
                                break;
                            case 'week':
                                getData(moment(dateStart).startOf('week').format("YYYY/MM/DD"), moment(dateStart).endOf('week').format("YYYY/MM/DD"));
                                break;
                            case 'month':
                                getData(moment(dateStart).startOf('month').format("YYYY/MM/DD"), moment(dateStart).endOf('month').format("YYYY/MM/DD"));
                                break;
                            case 'agenda':
                                getData(moment(dateStart).format("YYYY/MM/DD"), moment(dateStart).format("YYYY/MM/DD"));
                                break;
                        }
                        setOpen(false);
                        setAction("");


                    }
                })
        }



    }
    //拖曳移動預約
    const moveEvent = (prop) => {
        const { event, start, end, isAllDay: droppedOnAllDaySlot, resourceId } = prop
        // const { events } = this.state
        // let events = myEventsList
        let allDay = event.allDay
        if (isSingleEvent(event, prop) !== isSingle) {
            // console.log("不繼續")
            alert("時間重複")
            return;
        }
        // console.log(start)
        const { start: OriginalStart } = event;
        let timeStart = moment(OriginalStart, "YYYY/MM/DD HH:mm").toDate();
        if (timeStart < new Date()) {
            alert("時間已過，不允許變更")
            return;
        }

        if (start < new Date()) {
            alert("時間已過，新預約請選擇之後時間")
        } else {
            if (!event.allDay && droppedOnAllDaySlot) {
                allDay = true
            } else if (event.allDay && !droppedOnAllDaySlot) {
                allDay = false
            }

            // const nextEvents = events.map(existingEvent => {
            //     return existingEvent.roomBookingID == event.roomBookingID
            //         ? {
            //             ...existingEvent, start, end, allDay
            //             , resourceId //允許變換
            //         }
            //         : existingEvent
            // })
            // setEvent(nextEvents);
            // const newEvent = events.find(existingEvent => {
            //     return existingEvent.roomBookingID == event.roomBookingID
            // })
            // setUser(event);
            // handleSubmit()

            //TODO:UPDATE EVENT
            // let row = event.map(item => {
            //     return { ...item, color: departmentMap[item.department], resourceId: item.meetingRoomID, start: moment(item.start).format("YYYY-MM-DD HH:mm"), end: moment(item.end).format("YYYY-MM-DD HH:mm") }
            // })
            // console.log(event)
            // console.log(row)
            let newEvent = {
                ...event,
                start: moment(start).format("YYYY-MM-DD HH:mm"),
                end: moment(end).format("YYYY-MM-DD HH:mm"),
                resourceId,
                allDay
            }

            PF.instance({
                method: "POST",
                url: PF.url + "/RoomBooking/Update",
                data: Qs.stringify({ Action: "Update", parameter: newEvent }),
                // headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    const { TotalRecord, rows, ErrorMessage } = response.data;
                    // console.log(TotalRecord, rows, ErrorMessage)
                    if (TotalRecord <= 0) {
                        alert("錯誤")

                    } else {

                        switch (viewState) {
                            case 'day':
                                getData(moment(dateStart).format("YYYY/MM/DD"), moment(dateStart).format("YYYY/MM/DD"));
                                break;
                            case 'week':
                                getData(moment(dateStart).startOf('week').format("YYYY/MM/DD"), moment(dateStart).endOf('week').format("YYYY/MM/DD"));
                                break;
                            case 'month':
                                getData(moment(dateStart).startOf('month').format("YYYY/MM/DD"), moment(dateStart).endOf('month').format("YYYY/MM/DD"));
                                break;
                            case 'agenda':
                                getData(moment(dateStart).format("YYYY/MM/DD"), moment(dateStart).format("YYYY/MM/DD"));
                                break;
                        }
                        setOpen(false)
                        // setAction("")

                    }
                })



        }



        // alert(`${event.title} was dropped onto ${updatedEvent.start}`)
    }

    const onDropFromOutside = (prop) => {
        // const { draggedEvent } = this.state
        const { start, end, allDay, resourceId } = prop;
        const event = {
            id: draggedEvent.id,    //不能重複
            title: draggedEvent.title,
            start,
            end,
            allDay: allDay,
            resourceId: resourceId, //會換會議室
        }

        setDraggedEvent(null)
        moveEvent({ event, start, end })
    }
    const resizeEvent = (prop) => {
        const { event, start, end, resourceId } = prop;
        // console.log(start)
        // let events = myEventsList
        if (isSingleEvent(event, prop) !== isSingle) {
            // console.log("不繼續")
            alert("時間重複")
            return;
        }
        if (start < new Date()) {
            alert("時間已過，新預約請選擇之後時間")
        } else {

            // const nextEvents = events.map(existingEvent => {
            //     return existingEvent.id == event.id
            //         ? { ...existingEvent, start, end, resourceId }
            //         : existingEvent
            // })
            // setEvent(nextEvents)
            let newEvent = {
                ...event,
                start: moment(start).format("YYYY-MM-DD HH:mm"),
                end: moment(end).format("YYYY-MM-DD HH:mm"),
                resourceId,
            }

            PF.instance({
                method: "POST",
                url: PF.url + "/RoomBooking/Update",
                data: Qs.stringify({ Action: "Update", parameter: newEvent }),
                // headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    const { TotalRecord, rows, ErrorMessage } = response.data;
                    // console.log(TotalRecord, rows, ErrorMessage)
                    if (TotalRecord <= 0) {
                        alert("錯誤")

                    } else {

                        switch (viewState) {
                            case 'day':
                                getData(moment(dateStart).format("YYYY/MM/DD"), moment(dateStart).format("YYYY/MM/DD"));
                                break;
                            case 'week':
                                getData(moment(dateStart).startOf('week').format("YYYY/MM/DD"), moment(dateStart).endOf('week').format("YYYY/MM/DD"));
                                break;
                            case 'month':
                                getData(moment(dateStart).startOf('month').format("YYYY/MM/DD"), moment(dateStart).endOf('month').format("YYYY/MM/DD"));
                                break;
                            case 'agenda':
                                getData(moment(dateStart).format("YYYY/MM/DD"), moment(dateStart).format("YYYY/MM/DD"));
                                break;
                        }
                        setOpen(false)
                        setAction("")

                    }
                })

        }

    }
    const classes = useStyles();

    //改顏色
    const eventPropGetter = (event, start, end, isSelected) => {
        const backgroundColor = !_.isNil(event.color) ? event.color : deepPurple[500];
        return isSelected ? { style: { backgroundColor } } : {
            style: {
                backgroundColor,
                opacity: 0.80,
                // borderLeftColor: "black",
                borderBottom: "3px solid",
            },
            className: classes.event,
        }
    }
    const handleChange = event => {
        const { name, value } = event.target
        // console.log(name, value)
        setUser(prev => ({
            ...prev,
            [name]: value
        }))
        // setUser()
    }
    const handleTxtChange = event => {
        const { name, value } = event.target
        // console.log(name, value)
        setUser(prev => ({
            ...prev,
            [name]: value
        }))
    }
    const handleClose = event => {
        // const { name, value } = event.target
        // console.log(name, value)
        setOpen(false);
        setUser(prev => ({
        }));
        setAction("");

    }

    return (
        <Grid>
            <Paper elevation="3">
                <DragAndDropCalendar
                    min={moment('7:00', 'hh:mm').toDate()}  //每日顯示，排除7點之前
                    max={moment('19:00', 'hh:mm').toDate()} //每日顯示，排除19點之後
                    components={{
                        toolbar: props => <RBCToolbar {...props} getData={getData} />,
                        event: props => <CustomEvent {...props} />
                    }}
                    onNavigate={(date, view) => {
                        console.log('#### onNavigate');
                        console.log('#### date=', date);
                        console.log('#### view=', view);
                        setDateStart(date)
                        //this.setState({currentDate: date});
                    }}
                    onView={(view) => {
                        setViewState(view);
                        //this.setState({currentView: view});
                    }}
                    localizer={localizer}
                    events={myEventsList}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: "100vh" }}
                    selectable  //可以拖曳選擇
                    resizable   //可以變更
                    onSelectEvent={event => {   //CLICK event一下
                        setAction("Update")
                        setOpen(true);
                        setUser({
                            ...event,
                            start: moment(event.start, 'YYYY-MM-DD HH:mm').format("YYYY-MM-DD HH:mm"),
                            end: moment(event.end, 'YYYY-MM-DD HH:mm').format("YYYY-MM-DD HH:mm")
                        })
                    }}
                    onSelectSlot={handleSelect} //拖曳新增
                    eventPropGetter={eventPropGetter}
                    step={15}   //每隔15分
                    // timeslots={2}
                    popup
                    views={viewsList}   //決定可以看什麼，但不在裡面的defaultView要一起調整
                    defaultView={"week"}
                    resources={resourceMap}
                    resourceIdAccessor="resourceId"
                    resourceTitleAccessor="resourceTitle"
                    handleDragStart={handleDragStart}
                    onEventDrop={moveEvent}
                    dragFromOutsideItem={
                        displayDragItemInCell ? dragFromOutsideItem : null
                    }
                    onDropFromOutside={onDropFromOutside}
                    onEventResize={resizeEvent}
                />
            </Paper>
            <CustomModal
                open={open}
                setOpen={setOpen}
                logo={logo}
                settingObj={Object.values(settingObj)}
                handleDateChange={f => f}
                handleTxtChange={handleTxtChange}
                formRef={formRef}
                data={user}
                handleSubmit={handleSubmit}
                handleClose={handleClose}
                handleChange={handleChange}
                handleDelete={handleDelete}
                action={action}
            />
        </Grid>
    )
}
export default MyCalendar;
const viewsList = ['week', 'day']   //要顯示的view
const CustomEvent = (props) => {
    // console.log(props)
    const { title, event } = props
    return (<>
        <div class="rbc-event-content" style={{ height: "auto" }}>{event.title}</div>
        <Chip
            label={event.department}
            clickable size="small"
            color="primary"
            style={{ position: "absolute", right: "3px", bottom: "2px", left: "auto", top: "auto", backgroundColor: "white" }}
            variant="outlined"
        />

    </>
    )
}
//按鈕toolbar
function RBCToolbar(props) {
    React.useEffect(() => {
        const { view, date: mDate, getData } = props
        switch (view) {
            case 'day':
                getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                break;
            case 'week':
                getData(moment(mDate).startOf('week').format("YYYY/MM/DD"), moment(mDate).endOf('week').format("YYYY/MM/DD"));
                break;
            case 'month':
                getData(moment(mDate).startOf('month').format("YYYY/MM/DD"), moment(mDate).endOf('month').format("YYYY/MM/DD"));
                break;
            case 'agenda':
                getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                break;
            default:
        }

    }, [])
    const [viewState, setViewState] = useState(props.view);
    const [StudyTimechecked, setStudyTimechecked] = useState(false)
    const getCustomToolbar = () => {
        // const toolbarDate = props.date;
        const goToDayView = () => {
            let view = viewState;
            const { getData, date: mDate } = props
            switch (view) {
                case 'day':
                    getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                    break;
                case 'week':
                    getData(moment(mDate).startOf('week').format("YYYY/MM/DD"), moment(mDate).endOf('week').format("YYYY/MM/DD"));
                    break;
                case 'month':
                    getData(moment(mDate).startOf('month').format("YYYY/MM/DD"), moment(mDate).endOf('month').format("YYYY/MM/DD"));
                    break;
                case 'agenda':
                    getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                    break;
                default:
            }
            props.onView("day");
            setViewState("day");


        };
        const goToWeekView = () => {
            let view = viewState;
            const { getData, date: mDate } = props
            switch (view) {
                case 'day':
                    getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                    break;
                case 'week':
                    getData(moment(mDate).startOf('week').format("YYYY/MM/DD"), moment(mDate).endOf('week').format("YYYY/MM/DD"));
                    break;
                case 'month':
                    getData(moment(mDate).startOf('month').format("YYYY/MM/DD"), moment(mDate).endOf('month').format("YYYY/MM/DD"));
                    break;
                case 'agenda':
                    getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                    break;
                default:
            }

            props.onView("week");
            setViewState("week");
        };
        const goToMonthView = () => {
            let view = viewState;
            const { getData, date: mDate } = props
            switch (view) {
                case 'day':
                    getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                    break;
                case 'week':
                    getData(moment(mDate).startOf('week').format("YYYY/MM/DD"), moment(mDate).endOf('week').format("YYYY/MM/DD"));
                    break;
                case 'month':
                    getData(moment(mDate).startOf('month').format("YYYY/MM/DD"), moment(mDate).endOf('month').format("YYYY/MM/DD"));
                    break;
                case 'agenda':
                    getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                    break;
                default:
            }

            props.onView("month");
            setViewState("month");
        };
        const goToAgendaView = () => {
            let view = viewState;
            const { getData, date: mDate } = props
            switch (view) {
                case 'day':
                    getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                    break;
                case 'week':
                    getData(moment(mDate).startOf('week').format("YYYY/MM/DD"), moment(mDate).endOf('week').format("YYYY/MM/DD"));
                    break;
                case 'month':
                    getData(moment(mDate).startOf('month').format("YYYY/MM/DD"), moment(mDate).endOf('month').format("YYYY/MM/DD"));
                    break;
                case 'agenda':
                    getData(moment(mDate).format("YYYY/MM/DD"), moment(mDate).format("YYYY/MM/DD"));
                    break;
                default:
            }

            props.onView("agenda");
            setViewState("agenda");
        };
        const goToBack = () => {
            let view = viewState;
            // let mDate = props.date;
            const { getData, date: mDate } = props
            let newDate;
            if (view === "month") {
                newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1);
            } else if (view === "week") {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() - 7,
                    1
                );
            } else {    //date
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() - 1,
                    1
                );
            }
            switch (view) {
                case 'day':
                    getData(moment(newDate).format("YYYY/MM/DD"), moment(newDate).format("YYYY/MM/DD"));
                    break;
                case 'week':
                    getData(moment(newDate).startOf('week').format("YYYY/MM/DD"), moment(newDate).endOf('week').format("YYYY/MM/DD"));
                    break;
                case 'month':
                    getData(moment(newDate).startOf('month').format("YYYY/MM/DD"), moment(newDate).endOf('month').format("YYYY/MM/DD"));
                    break;
                case 'agenda':
                    getData(moment(newDate).format("YYYY/MM/DD"), moment(newDate).format("YYYY/MM/DD"));
                    break;
                default:
            }

            props.onNavigate("prev", newDate);

        };
        const goToNext = () => {
            let view = viewState;
            const { getData, date: mDate } = props
            let newDate;
            if (view === "month") {
                newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1, 1);
            } else if (view === "week") {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() + 7,
                    1
                );
            } else {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() + 1,
                    1
                );
            }
            console.log(newDate);
            switch (view) {
                case 'day':
                    getData(moment(newDate).format("YYYY/MM/DD"), moment(newDate).format("YYYY/MM/DD"));
                    break;
                case 'week':
                    getData(moment(newDate).startOf('week').format("YYYY/MM/DD"), moment(newDate).endOf('week').format("YYYY/MM/DD"));
                    break;
                case 'month':
                    getData(moment(newDate).startOf('month').format("YYYY/MM/DD"), moment(newDate).endOf('month').format("YYYY/MM/DD"));
                    break;
                case 'agenda':
                    getData(moment(newDate).format("YYYY/MM/DD"), moment(newDate).format("YYYY/MM/DD"));
                    break;
                default:
            }

            props.onNavigate("next", newDate);
        };

        const goToToday = () => {
            const now = new Date();
            props.date.setMonth(now.getMonth());
            props.date.setYear(now.getFullYear());
            props.date.setDate(now.getDate());
            props.onNavigate("current");
        };

        const goToBackYear = () => {
            let mDate = props.date;
            let newDate = new Date(mDate.getFullYear() - 1, 1);
            props.onNavigate("prev", newDate);
        };

        const goToNextYear = () => {
            let mDate = props.date;
            let newDate = new Date(mDate.getFullYear() + 1, 1);
            props.onNavigate("next", newDate);
        };

        const month = () => {
            const date = moment(props.date);
            let month = date.format("MMMM");
            let day = date.format("D");

            return (
                <span className="rbc-toolbar-label rbc-date">
                    <i className="far fa-calendar"></i> <span>{`${month} ${day}`}</span>
                </span>
            );
        };
        const year = () => {
            const date = moment(props.date);
            let year = date.format("YYYY");

            return (
                <span className="rbc-btn-group">
                    {viewState === "month" && (
                        <button type="button" onClick={goToBackYear}>
                            <span className="prev-icon">&#8249;&#8249;</span>
                        </button>
                    )}
                    <span className="rbc-toolbar-label">{year}</span>
                    {viewState === "month" && (
                        <button type="button" onClick={goToNextYear}>
                            <span className="prev-icon">&#8250;&#8250;</span>
                        </button>
                    )}
                </span>
            );
        };

        const day = () => {
            let view = viewState;
            const date = moment(props.date);
            let day;
            if (view === "day") {
                day = date.format("ddd") + " " + date.format("Do");
            }
            return <span className="rbc-toolbar-label rbc-toolbar">{day}</span>;
        };
        const week = () => {
            let view = viewState;
            const date = moment(props.date);
            let month1 = date.startOf('week').format("MMMM");
            let weekD1 = date.startOf('week').format("D");

            let month2 = date.endOf('week').format("MMMM");
            let weekD2 = date.endOf('week').format("D");
            return <span className="rbc-toolbar-label rbc-toolbar">{`${month1} ${weekD1} - `}{month1 === month2 ? `${weekD2}` : `${month2} ${weekD2}`}</span>;
        };

        return (
            <div className="rbc-toolbar">

                <span className="rbc-btn-group">
                    <button className="next-icon today" onClick={goToToday}>
                        {viewState === "day" ? "TODAY" : "This Week"}
                    </button>

                    <button className="prev-icon" id="prev-btn-icon" onClick={goToBack}>
                        &#8249;
                    </button>

                    <button className="next-icon" id="next-btn-icon" onClick={goToNext}>
                        &#8250;
                    </button>
                </span>
                {/* 置中顯示日期格式 */}
                <span className="rbc-toolbar-label rbc-toolbar">{props.label}</span>
                <span style={{ float: "right" }}>
                    <ButtonGroup color="secondary" >
                        {viewsList.indexOf("month") >= 0 ? (<Button onClick={goToMonthView} style={{ color: deepOrange[500], borderColor: deepOrange[500] }}>
                            <span >Month</span>
                        </Button>) : null}
                        {viewsList.indexOf("week") >= 0 ? (<Button onClick={goToWeekView} style={{ color: deepOrange[500], borderColor: deepOrange[500] }}>
                            <span >Week</span>
                        </Button>) : null}
                        {viewsList.indexOf("day") >= 0 ? (<Button onClick={goToDayView} style={{ color: deepOrange[500], borderColor: deepOrange[500] }}>
                            <span >Day</span>
                        </Button>) : null}
                        {viewsList.indexOf("agenda") >= 0 ? (<Button onClick={goToAgendaView} style={{ color: deepOrange[500], borderColor: deepOrange[500] }}>
                            <span >Agenda</span>
                        </Button>) : null}
                    </ButtonGroup>
                </span>
            </div>
        );
    };

    return <>{getCustomToolbar()}</>;
}